import { useRef } from 'react'
import SettingsPortal from '../../components/SettingsPortal'
import { StyledBody, StyledRoot } from '../Cortext/Cortext'
import ChatInput from '../../components/ChatInput'
import { useVision } from './useVision'
import { FormikProvider } from 'formik'

import { StyledSettings } from '../Cortext/Settings/SettingsStyles.css'

import ImagesChatWindow from '../../components/ImagesChatWindow'

import FormikTextField from 'components/TextFieldFormik'
import { chatOptions, enginesOptions, synapseOptions } from './types'
import Slider from 'components/Slider'
import TextChatWindow from '../../components/TextChatWindow'
import SubnetDescription from '../../components/SubnetDescription'
import DropdownFormik from 'components/DropdownFormik'

const Vision = () => {
    const visionRef = useRef(null)

    const { formik, responseLoading, messages, images } = useVision()

    const { synapse_type, engine, chat_model } = formik.values

    const chatSynapse = synapse_type === 'Chat'
    const TextToImageSynapse = synapse_type === 'TextToImage'

    return (
        <FormikProvider value={formik}>
            <StyledRoot ref={visionRef}>
                <StyledBody>
                    {TextToImageSynapse && (
                        <ImagesChatWindow
                            loading={responseLoading}
                            images={images}
                            displayPrompt={''}
                        />
                    )}
                    {chatSynapse && (
                        <TextChatWindow loading={responseLoading} messages={messages} />
                    )}

                    <ChatInput formik={formik} fieldName='message' />
                </StyledBody>
            </StyledRoot>

            <SettingsPortal portalRef={visionRef}>
                <StyledSettings>
                    <SubnetDescription
                        title={'19. Vision'}
                        description={
                            'Subnet 19 is decentralised inference of AI models. Supporting various text & image models'
                        }
                    />

                    <DropdownFormik
                        label='Synapse'
                        fieldName={'synapse_type'}
                        fieldValue={synapse_type}
                        options={synapseOptions}
                        setFieldValue={formik.setFieldValue}
                    />
                    <FormikTextField name='axon_uid' placeholder={'axon_uid'} label={'Axon UID'} />

                    <FormikTextField name='timeout' placeholder={'timeout'} label={'Timeout'} />
                    <FormikTextField name='seed' placeholder={'seed'} label={'Seed'} />

                    {TextToImageSynapse && (
                        <>
                            <DropdownFormik
                                label='Engine'
                                fieldName={'engine'}
                                fieldValue={engine}
                                options={enginesOptions}
                                setFieldValue={formik.setFieldValue}
                            />
                            <FormikTextField name='width' placeholder={'width'} label={'Width'} />
                            <FormikTextField
                                name='height'
                                placeholder={'height'}
                                label={'Height'}
                            />
                            <FormikTextField
                                name='cfg_scale'
                                placeholder={'cfg_scale'}
                                label={'cfg scale'}
                            />

                            <Slider
                                name='steps'
                                label='Steps'
                                min={1}
                                max={50}
                                step={1}
                                value={formik.values.steps}
                                onChange={value => formik.setFieldValue('steps', value)}
                            />
                        </>
                    )}

                    {chatSynapse && (
                        <>
                            <DropdownFormik
                                label='Model'
                                fieldName={'chat_model'}
                                fieldValue={chat_model}
                                options={chatOptions}
                                setFieldValue={formik.setFieldValue}
                            />
                            <Slider
                                name='max_tokens'
                                label='Max Tokens'
                                min={1}
                                max={4096}
                                step={1}
                                value={formik.values.max_tokens}
                                onChange={value => formik.setFieldValue('max_tokens', value)}
                            />
                            <Slider
                                name='temperature'
                                label='Temperature'
                                min={0}
                                max={1}
                                step={0.1}
                                value={formik.values.temperature}
                                onChange={value => formik.setFieldValue('temperature', value)}
                            />
                            <FormikTextField name='top_p' placeholder={'top_p'} label={'top_p'} />
                        </>
                    )}
                </StyledSettings>
            </SettingsPortal>
        </FormikProvider>
    )
}

export default Vision
